import { schema } from 'normalizr';
import integrationRuleSchema from './integrationRule';

const coopIntegrationSchema = new schema.Object({
  rules: new schema.Array(integrationRuleSchema),
});

export default coopIntegrationSchema;
